









































import { Component, Vue, Prop } from 'vue-property-decorator';
import router from '../../router';
import { vxm } from '../../store.vuex';
import RegistrationCard from './Card.vue';
import Container from './Container.vue';

@Component({
  name: 'AppRetrieveOldEmailConfirmation',
  components: {
    RegistrationCard,
    Container,
  },
})
export default class AppRetrieveOldEmailConfirmation extends Vue {
  $wlToastr: any;

  redirectLogin() {
    console.log('Redirecting to login');
    router.push({ name: 'AppSignup' });
  }

  redirectValidate() {
    const vm = this;
    const respPromise: any = vxm.users.retrieveEmail();
    Promise.all([respPromise]).then((values) => {
      if (values[0].status === 'success') {
        router.push({ name: 'AppRetrievedEmailVerification' });
      } else {
        vm.$wlToastr(
          'error',
          'Error while sending retrived email SMS',
          'Send SMS',
        );
      }
    });
  }
}
